import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

export default function ClaimRewardError({ onClose }) {
  const { t } = useTranslation(null, { useSuspense: false });

  return (
    <div className="cashout-failed-result text-center">
      <div className="modal-header">
        <a
          className="close phoenix-icon phoenix-icon-cross"
          onClick={onClose}
        />
        <h4 className="modal-title text-center">
          {t('cashout_cash_out_error_description')}
        </h4>
      </div>

      <div className="modal-body">
        <p className="text-muted mb-4">
          {t('generic_error_description')}
        </p>
      </div>
    </div>
  );
}

ClaimRewardError.propTypes = {
  onClose: PropTypes.func.isRequired,
};
